import { departmentConstants } from '../constant/department.constants';
import { department } from '../services/department.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getDepartmentList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        department.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(departmentList) { 
        return { type: departmentConstants.GET_SUCCESS, departmentList }; 
    }
}

export const addDepartment = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        department.add(data)
            .then(
                res => {
                    if(!res) return;

                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                                dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: departmentConstants.ADD_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: departmentConstants.ADD_FAILURE, error }; 
    }
}

export const deleteDepartment = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        department.delete(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: departmentConstants.DELETE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: departmentConstants.DELETE_FAILURE, error }; 
    }
}

export const updateDepartment = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        department.update(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APIUpdatedSuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                            
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: departmentConstants.UPDATE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: departmentConstants.UPDATE_FAILURE, error }; 
    }
}